import { Button, withStyles, TextField } from '@material-ui/core';

const EllipseButton = withStyles(theme => ({
    root: {
        borderRadius: 40,
        color: "white"
    }
}))(Button);

const SearchTextField = withStyles(theme => ({
    root: {
        [`& fieldset`]: {
            borderRadius: 40,
        },
        padding: "0px",
        width: '30%'
    }
}))(TextField);

export { EllipseButton, SearchTextField };;